import { globalStore } from '../Redux/ReduxStore';
import { apryseEventSlice } from '../Redux/ApryseEventSlice';
import type { Core } from '@pdftron/webviewer';

export class ApryseUpdater {
    private static _selectedAnnotations: Core.Annotations.Annotation[] = [];
    private static _currentPage = 1;
    private static _currentScale = 1;

    static get selectedAnnotation(): Core.Annotations.Annotation | null {
        return this._selectedAnnotations.length === 1 ? this._selectedAnnotations[0] : null;
    }

    static get selectedAnnotations(): Core.Annotations.Annotation[] {
        return this._selectedAnnotations;
    }

    static set selectedAnnotations(annotations: Core.Annotations.Annotation[]) {
        this._selectedAnnotations = annotations;
        // Only store Selected annotation Ids in Redux state!
        globalStore.dispatch(
            apryseEventSlice.actions.updateSelectedAnnotations(annotations.map(annot => annot.Id)),
        );
    }

    static get currentPage(): number {
        return this._currentPage;
    }

    static set currentPage(currentPage: number) {
        this._currentPage = currentPage;
        globalStore.dispatch(apryseEventSlice.actions.updateCurrentPage(currentPage));
    }

    static get currentScale(): number {
        return this._currentScale;
    }

    static set currentScale(newScale: number) {
        this._currentScale = newScale;
        globalStore.dispatch(apryseEventSlice.actions.updateCurrentScale(newScale));
    }
}
